export default "__VITE_PUBLIC_ASSET__823b3b19__"